import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { height } from "@mui/system";

const MapComponent = ({maps}) => {
 

  return (
    <Container maxWidth="lg" style={{ marginTop: "-20px",minWidth:300, marginBottom: "20px" }}>
      {maps.map((map) => (
        <Box key={map.id} style={{ marginBottom: "40px" }}>
          <Typography
            variant="h6"
            style={{ marginBottom: "10px", fontWeight: "bold" }}
          >
            {/* {map.title} */}
          </Typography>
          <Box
            style={{
              position: "relative",
              width: "100%",
              height: 500,
              paddingTop: "56.25%", // 16:9 Aspect Ratio
              overflow: "hidden",
              borderRadius: "10px", // Optional: Rounded corners for the map
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional: Shadow effect
            }}
          >
            <iframe
              src={map.url}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
              allowFullScreen
              title={map.title}
            />
          </Box>
        </Box>
      ))}
    </Container>
  );
};

export default MapComponent;
